import { Stack, Typography, Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import policyService from "../../services/policyService";
import
{
	cardStyle,
	greyBorderStyle,
	ThemeModeContext,
} from "../../shared/Theme";
import { green, pink } from "../../shared/colours";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

const HubServiceCard = (props) =>
{
	const navigate = useNavigate();
	const themeModeContext = useContext(ThemeModeContext);

	let [policyStats, setPolicyStats] = useState(policyService.policyStats);

	const handleTitleClick = () =>
	{
		if (props.isLocal)
		{
			navigate(props.url);
		} else
		{
			window.open(props.url, "_self");
		}
	};

	useEffect(() =>
	{
		setPolicyStats(policyService.policyStats);
	}, []);

	return (
		<React.Fragment>

			<Stack
				className="button"
				direction="column"
				spacing={0.1}
				alignItems="center"
				justifyContent="center"
				
				sx={{
					width: "20em",
					height: "13em",
					border: `solid 2px ${green}`,
					borderRadius: "1.5em",
					"&:hover": { cursor: "pointer" },
				}}
			>
				<Box
					sx={{
						height: "1em",
						width: "100%",
						textAlign: "right",
					}}
				>
					{props.helpToggle && (
						<HelpOutlineRoundedIcon
							onClick={props.helpToggle}
							sx={{
								position: "relative",
								top: "0.4em",
								right: "0.4em",
								width: "1em",
								height: "1em",
							}}
						/>
					)}
				</Box>
				<Box
					onClick={handleTitleClick}
					sx={{
						width: "100%",
						height: "100%",
						paddingLeft: "0.5em",
						paddingRight: "0.5em",
						paddingBottom: "0.8em",
						"&:hover": { cursor: "pointer" },
					}}
				>
					<Stack
						direction="row"
						position="relative"
						spacing={0.1}
						alignItems="center"
						justifyContent="center"
						onClick={handleTitleClick}
						sx={{
							height: "10em",
							margin: "1em",
							'&:hover': { cursor: "pointer" }
						}}
					>
						<Typography
							variant="h5"
							sx={{
								textAlign: "center",
								marginTop: "1em",
								paddingBottom: "0.5em",
								cursor: "pointer",
								fontWeight: "bold",
							}}
							onClick={handleTitleClick}
						>
							{props.title}
						</Typography>
						<Box
							sx={{
								width: "0.65em",
								height: "0.65em",
								background: pink,
								borderRadius: "1em",
							}}
						/>
					</Stack>
				</Box>
			</Stack>
		</React.Fragment>
	);
};

export default HubServiceCard;
